/**TextBlockWithTitle
 * index.js
 * Created by Pavel Akulov on 18.06.2019.
 * Email: akulov@magora-systems.com
 * Company: Magora Systems LLC
 * Website: http://magora-systems.com
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Address } from 'components/Address';
import { Tooltip } from '../Tooltip';
import { InfoIcon } from '../SvgIcons';

import './text-block-with-title.scss';

export const TextBlockWithTitle = (props) => {
  const {
    className,
    title,
    description,
    descriptionClassName,
    text,
    tooltipInfo,
    address,
    tooltipWidth,
    tooltipType,
    withIcon,
    dataTestId,
  } = props;

  return (
    <div className={`text-block-with-title ${className}`}>
      <h3 className="text-block-with-title__title">
        <div className="text-block-with-title__header">
          {withIcon}
          {title}
        </div>
        {tooltipInfo && (
          <div className="text-block-with-title__tooltip">
            <Tooltip width={tooltipWidth} type={tooltipType} info={tooltipInfo}>
              <InfoIcon width="16px" height="16px" />
            </Tooltip>
          </div>
        )}
      </h3>
      {description && <div className={descriptionClassName}>{description}</div>}
      {address && (
        <Address
          className="text-block-with-title__address mt-3"
          address={address}
        />
      )}
      <div
        className="text-block-with-title__text mt-3"
        data-testid={`${dataTestId}-value`}
      >
        {text}
      </div>
    </div>
  );
};
TextBlockWithTitle.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
  text: PropTypes.any,
  tooltipInfo: PropTypes.string,
  address: PropTypes.string,
  tooltipWidth: PropTypes.string,
  tooltipType: PropTypes.string,
  withIcon: PropTypes.element,
};

TextBlockWithTitle.defaultProps = {
  title: '',
  className: '',
  text: '',
  tooltipInfo: '',
  address: '',
  tooltipWidth: '150px',
  tooltipType: 'bottom-left',
  withIcon: null,
};
